import React from 'react';
import { aboutData } from '../data/mock';
import { CheckCircle2 } from 'lucide-react';

const About = () => {
  const values = [
    'Escucha activa y empática',
    'Estrategias legales personalizadas',
    'Transparencia en cada proceso',
    'Compromiso con tus derechos'
  ];

  return (
    <section id="nosotros" className="py-20 md:py-32 bg-[rgb(var(--bg-primary))]">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://images.unsplash.com/photo-1551836022-d5d88e9218df"
                alt="Equipo Ochoa Herrera & Asociados"
                className="w-full h-[500px] object-cover shadow-2xl"
                loading="lazy"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-[rgb(var(--burgundy-primary))] -z-0"></div>
          </div>

          {/* Right Column - Content */}
          <div>
            <h2 className="heading-1 mb-6 text-[rgb(var(--burgundy-primary))]">
              {aboutData.title}
            </h2>
            <div className="w-20 h-1 bg-[rgb(var(--burgundy-primary))] mb-8"></div>
            
            <p className="body-large text-[rgb(var(--text-primary))] mb-8 leading-relaxed">
              {aboutData.content}
            </p>

            {/* Values List */}
            <div className="space-y-4 mb-8">
              {values.map((value, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-[rgb(var(--burgundy-primary))] flex-shrink-0 mt-0.5" />
                  <span className="body-regular text-[rgb(var(--text-primary))]">
                    {value}
                  </span>
                </div>
              ))}
            </div>

            {/* Location Badge */}
            <div className="inline-flex items-center gap-2 bg-[rgb(var(--bg-secondary))] px-6 py-3 mt-6">
              <div className="w-2 h-2 rounded-full bg-[rgb(var(--burgundy-primary))] animate-pulse"></div>
              <span className="body-small font-medium text-[rgb(var(--text-primary))]">
                Con sede en Cuernavaca, Morelos
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
